import script from "./RequestsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestsTable.vue?vue&type=script&setup=true&lang=ts"

import "./RequestsTable.vue?vue&type=style&index=0&id=3a2ae91a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a2ae91a"]])

export default __exports__